import LoaderStrings from 'LoaderStrings';
export default LoaderStrings.telepray.Errors;
